import { getMajorMedCarrierTypeText, getMajorMedPolicyStatusText } from "../../../lib/labels"
import { showMajorMedOnPrint } from "../../../lib/misc"
import { formatCurrency } from "../../../lib/script"
import CheckboxCell from "../../common/interactive/CheckboxCell"

export default function MajorMedPart({dataItem, caseData, classes}) {
    const hiofSelected = caseData?.hiof_selected

    return <>
        {dataItem && showMajorMedOnPrint(dataItem) && <>
            <h4 className={classes.flex_betwen}>Major Medical 
                <div className={classes.status}>
                    {hiofSelected == 1 && <CheckboxCell label={'Opt-In'} checked={true} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/>}
                    {hiofSelected == 0 && <CheckboxCell label={'Opt-Out'} checked={true} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/>}
                </div>
            </h4>
            <div className={classes.background_container}>
                <div className={classes.row}>Carrier: {dataItem.insurance_carrier?.name}</div>
                {dataItem.carrier_types && <div className={classes.row}>
                    Carrier Types: {getMajorMedCarrierTypeText(dataItem.carrier_types)}
                </div>}
                
                {dataItem.policy_status && <div className={classes.row}>Policy Status: <b>{getMajorMedPolicyStatusText(dataItem.policy_status)}</b></div>}
                {(dataItem.office_copay_oon || dataItem.office_copay_inn) && <div className={classes.row}>Office Copay: <b>{`OON ${dataItem.office_copay_oon ? '$' + formatCurrency(dataItem.office_copay_oon) : '-'} - INN ${dataItem.office_copay_inn ? '$' + formatCurrency(dataItem.office_copay_inn) : '-'}`}</b></div>}              
       
                {(dataItem.deductible_oon || dataItem.deductible_inn) && <div className={classes.row}>Deductibles: <b>{`OON ${dataItem.deductible_oon ? '$' + formatCurrency(dataItem.deductible_oon) : '-'} - INN ${dataItem.deductible_inn ? '$' + formatCurrency(dataItem.deductible_inn) : '-'}`}</b></div>}
                
                {dataItem.verified ? <>
                    <hr />
                    <div>Verified by <b>{dataItem.verified_by}</b> at <b>{dataItem.verified_date}</b></div>
                </> : ''}     
            </div>
        </>}
    </>
}